import { useContext, createContext, useMemo } from "react";
import { withRouter } from "react-router-dom";

class RouterDefinition {
  params = null
  location = null
  match = null
}

const RouterContext = createContext(new RouterDefinition)

export const useParams = () => {
  const { params } = useContext(RouterContext)

  return params
}

export const useLocation = () => {
  const { location } = useContext(RouterContext)

  return location
}

export const useMatch = () => {
  const { match } = useContext(RouterContext)

  return match
}

function RouterProvider({ children, match, location }) {
  const { params } = match

  const value = useMemo(() => new class extends RouterDefinition {
    params = params
    location = location
    match = match
  }, [match, params, location])

  return <RouterContext.Provider value={value} >
    {children}
  </RouterContext.Provider >
}

export default withRouter(RouterProvider)
